module.exports = __webpack_public_path__ + "img/checkbox-checked-green.a5c547ee.svg";